
// import { GET_CUSTODY_FAILURE, GET_CUSTODY_REQUEST, GET_CUSTODY_SUCCESS } from "./custodyTypes";

import { GET_DPP_DOCUMENTS_FAILURE, GET_DPP_DOCUMENTS_REQUEST, GET_DPP_DOCUMENTS_SUCCESS, UPLOAD_IMAGES_FAILURE, UPLOAD_IMAGES_REQUEST, UPLOAD_IMAGES_SUCCESS } from "./documentsTypes";

const initialState = {
  loading: false,
  documents: [],
  error: "",
};

const getDppDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DPP_DOCUMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DPP_DOCUMENTS_SUCCESS:
      return {
        loading: false,
        documents: action.payload,
        error: "",
      };
    case GET_DPP_DOCUMENTS_FAILURE:
      return {
        loading: false,
        documents: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

const initialStated = {
  loading: false,
  documents: [],
  error: "",
};
const CLEAR_IMAGES = "CLEAR_IMAGES";


const getDppDocumentsImageReducer = (state = initialStated, action) => {
  switch (action.type) {
    case UPLOAD_IMAGES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_IMAGES_SUCCESS:
      return {
        loading: false,
        documents: action.payload,
        error: "",
      };
    case UPLOAD_IMAGES_FAILURE:
      return {
        loading: false,
        documents: [],
        error: action.payload,
      };
    case CLEAR_IMAGES:
      return {
        ...state,
        documents: [],
        error: "",
      };
    default:
      return state; 
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export { getDppDocumentsReducer,
  getDppDocumentsImageReducer
    //  getDocumentTypeWithPaginationReducer 
    };
